import { PARTTIME_RESUME_DEFAULT_ID } from 'Constants/ResumeTypes';
import LocalStorageManager from 'Utils/LocalStorageManager';
import LocalStorageManagerV1 from 'Utils/LocalStorageManagerV1';
import CombinedStorage from 'Utils/storage/CombinedStorage';
import EncryptedStorage from 'Utils/storage/EncryptedStorage';
import NativeStorage from 'Utils/storage/NativeStorage';
export default class FormValuesMigrator {
    static async migrateDataFromLocalToNativeStorage() {
        const IS_MIGRATED_TO_NATIVE_STORAGE = 'rirekisho_native_storage_migrated';
        if (localStorage.getItem(IS_MIGRATED_TO_NATIVE_STORAGE) === '1') {
            return;
        }
        const nativeAvailable = await NativeStorage.instance().isAvailable();
        const encryptAvailable = await EncryptedStorage.instance().isAvailable();
        const migrateKeys = [
            'rirekisho_multistep_values',
            'rirekisho_multistep_values_v1',
            'rirekisho_print_history'
        ];
        if (nativeAvailable && encryptAvailable) {
            for (let i = migrateKeys.length - 1; i >= 0; i--) {
                const key = migrateKeys[i];
                const values = await NativeStorage.instance().getItem(key);
                const oldValues = await EncryptedStorage.instance().getItem(key);
                if (values === null && oldValues !== null) {
                    await NativeStorage.instance().setItem(key, oldValues);
                }
            }
            localStorage.setItem(IS_MIGRATED_TO_NATIVE_STORAGE, '1');
        }
    }
    static async migrateDataFromV0toV1() {
        const IS_MIGRATED_TO_V1_STORAGE_KEY = 'rirekisho_multistep_values_v0_migrated';
        const migratedToV1 = localStorage.getItem(IS_MIGRATED_TO_V1_STORAGE_KEY);
        const oldValue = await CombinedStorage.instance().getItem('rirekisho_multistep_values');
        if (migratedToV1 === 'true' || oldValue === null) {
            return;
        }
        await LocalStorageManager.instance().ready();
        await LocalStorageManagerV1.instance().ready();
        const v0Values = LocalStorageManager.instance().getValues();
        const resumeId = PARTTIME_RESUME_DEFAULT_ID;
        if (v0Values) {
            v0Values.lastWizardPath = v0Values.lastWizardPath || {
                resume: `/parttimeCreate/${resumeId}/basicInfo`
            };
            v0Values.lastWizardPath.resume = v0Values.lastWizardPath.resume?.replace('/create', `/parttimeCreate/${resumeId}`);
            await LocalStorageManagerV1.instance().getOrCreateRecentResume(resumeId, v0Values);
        }
        localStorage.setItem(IS_MIGRATED_TO_V1_STORAGE_KEY, 'true');
    }
}
